import gql from 'graphql-tag';

export const GET_STARTED = gql`
  mutation GetStarted($credential: signupInput) {
    signUp(credential: $credential)
  }
`;